/* Custom variant default selections */

document.addEventListener('DOMContentLoaded', function () {
  // Function to select default options
  function selectDefaults() {
    // Select "MATTE" radio button if available and not already selected
    const matteRadio = document.querySelector(
      'input[type="radio"][name="options[Finish]"][value="MATTE"]'
    );
    if (matteRadio && !matteRadio.checked && !matteRadio.disabled && !matteRadio.classList.contains('unavailable')) {
      matteRadio.click();
    }

    // Select 4th radio option under "Size" if available and not already selected
    const amountRadios = document.querySelectorAll(
      'input[type="radio"][name="options[Size]"]'
    );
    if (amountRadios.length >= 4 && !amountRadios[3].checked && !amountRadios[3].disabled && !amountRadios[3].classList.contains('unavailable')) {
      amountRadios[3].click();
    }
  }

  // Run on initial page load
  selectDefaults();

  // Watch for quick buy drawer content changes
  const quickBuySlot = document.getElementById('quick-buy-drawer-slot');
  if (quickBuySlot) {
    const observer = new MutationObserver(function(mutations) {
      // When drawer content changes, run selectDefaults after a small delay
      // to let Alpine.js initialize the variant picker
      setTimeout(selectDefaults, 200);
    });
    
    observer.observe(quickBuySlot, {
      childList: true,
      subtree: true
    });
  }
});
